import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const EyeOn = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        d='M2.02197 12.3719C2.02197 12.3719 5.02197 5.37195 12.022 5.37195C19.022 5.37195 22.022 12.3719 22.022 12.3719C22.022 12.3719 19.022 19.3719 12.022 19.3719C5.02197 19.3719 2.02197 12.3719 2.02197 12.3719Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.022 15.3719C13.6788 15.3719 15.022 14.0288 15.022 12.3719C15.022 10.7151 13.6788 9.37195 12.022 9.37195C10.3651 9.37195 9.02197 10.7151 9.02197 12.3719C9.02197 14.0288 10.3651 15.3719 12.022 15.3719Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
